import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { ToggleButton } from '@prisjakt/ui/button/variants';

export const VariantGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 2px;
`;

type SelectableButtonProps = {
  disabled: boolean;
};

export const SelectableButton = styled(ToggleButton)<SelectableButtonProps>(
  props => css`
    display: flex;
    min-height: 40px;
    min-width: 80px;
    margin-right: ${layout.measurements.spacing050};

    ${props.disabled &&
      css`
        && {
          pointer-events: initial;
          cursor: not-allowed;
        }
      `}
  `
);
